export const targetingActionTypes = ['onPageLoad', 'onPageLoadAndLazyLoad', 'targetAll'] as const

export type TargetingActionType = (typeof targetingActionTypes)[number]
